import originFields from '../defaults/PointOfOriginFields.json';
import perimeterFields from '../defaults/UncertifiedPerimeterFields.json';
import enums from '../defaults/Enums.json';
import moment from 'moment';

export function getValidationInfo(validationType, attributes, fieldInfos) 
{
  if(validationType === enums.validationType.origin)
  {
    return getOriginValidationInfo(attributes,fieldInfos);
  }
  else if(validationType === enums.validationType.perimeter)
  {
    return getPerimeterValidationInfo(attributes, fieldInfos);
  }
  else if(validationType === enums.validationType.bypassValidation)
  {
    return {
      isValid: true,
      invalidFields: [],
      errors: {}
    };
  }
  else {
    return {
      isValid: false,
      invalidFields: [],
      errors: {}
    };
  }
}

export function getPolygonCreateDate(attributes) {
  //originFields.containmentDate
  //originFields.fireGrowthCessationDate
  //originFields.ControlDateTime
  //originFields.outDate

  var dateArray = [];

  if (attributes[originFields.containmentDate]) {
    dateArray.push(new Date(attributes[originFields.containmentDate]));
  }

  if (attributes[originFields.fireGrowthCessationDate]) {
    dateArray.push(new Date(attributes[originFields.fireGrowthCessationDate]));
  }

  if (attributes[originFields.controlDate]) {
    dateArray.push(new Date(attributes[originFields.controlDate]));
  }

  if (attributes[originFields.outDate]) {
    dateArray.push(new Date(attributes[originFields.outDate]));
  }

  dateArray.push(new Date());
  var min = dateArray[0];
  for (var i = 1; i < dateArray.length; i++) 
  {
  if (dateArray[i] < min)
    min = dateArray[i];
  }

  return min.getTime();
}

export function formatIdentifierForApi(incidentId)
{
  //console.log(incidentId);
  if (incidentId)
  {
    let formattedId = incidentId.replace("{", "");
    formattedId = formattedId.replace("}", "");
    return "{" + formattedId.toUpperCase() + "}";
  }
    else
  {
      return '';
  }
}

export function isCurrentYearIncident(incident)
{
  const incidentDiscoveryDate = new Date(incident.attributes[originFields.discoveryDate]);
  const currentDate = new Date();

  return currentDate.getFullYear() === incidentDiscoveryDate.getFullYear();
}

export function getPerimeterSource(incident)
{
  if (isIncidentCertified(incident))
  {
    return enums.perimeterSource.finalFireFeatureService;
  }
  else if(isCurrentYearIncident(incident))
  {
    return enums.perimeterSource.nifs;
  }
  else
  {
    return enums.perimeterSource.fireHistoryFeatureService;
  }
}

export function getCountiesForState(stateCode)
{
  if (Array.isArray(stateCode) && stateCode.length === 1)
  {
  switch (stateCode[0])
  {
  case "US-AL":
  	return ['Autauga','Baldwin','Barbour','Bibb','Blount','Bullock','Butler','Calhoun','Chambers','Cherokee','Chilton','Choctaw','Clarke','Clay','Cleburne','Coffee','Colbert','Conecuh','Coosa','Covington','Crenshaw','Cullman','Dale','Dallas','De Kalb','Elmore','Escambia','Etowah','Fayette','Franklin','Geneva','Greene','Hale','Henry','Houston','Jackson','Jefferson','Lamar','Lauderdale','Lawrence','Lee','Limestone','Lowndes','Macon','Madison','Marengo','Marion','Marshall','Mobile','Monroe','Montgomery','Morgan','Perry','Pickens','Pike','Randolph','Russell','St. Clair','Shelby','Sumter','Talladega','Tallapoosa','Tuscaloosa','Walker','Washington','Wilcox','Winston'];

  case "US-AK":
  	return ['Aleutians East','Aleutians West','Anchorage','Bethel','Bristol Bay','Denali','Dillingham','Fairbanks North Star','Haines','Juneau','Kenai Peninsula','Ketchikan Gateway','Kodiak Island','Lake And Peninsula','Matanuska-Susitna','Nome','North Slope','Northwest Arctic','Prince of Wales-Outer Ketchikan','Sitka','Skagway','Southeast Fairbanks','Valdez-Cordova','Wade Hampton','Wrangell','Yakutat'];

  case "US-AZ":
  	return ['Apache','Cochise','Coconino','Gila','Graham','Greenlee','La Paz','Maricopa','Mohave','Navajo','Pima','Pinal','Santa Cruz','Yavapai','Yuma'];

  case "US-AR":
  	return ['Arkansas','Ashley','Baxter','Benton','Boone','Bradley','Calhoun','Carroll','Chicot','Clark','Clay','Cleburne','Cleveland','Columbia','Conway','Craighead','Crawford','Crittenden','Cross','Dallas','Desha','Drew','Faulkner','Franklin','Fulton','Garland','Grant','Greene','Hempstead','Hot Spring','Howard','Independence','Izard','Jackson','Jefferson','Johnson','Lafayette','Lawrence','Lee','Lincoln','Little River','Logan','Lonoke','Madison','Marion','Miller','Mississippi','Monroe','Montgomery','Nevada','Newton','Ouachita','Perry','Phillips','Pike','Poinsett','Polk','Pope','Prairie','Pulaski','Randolph','St. Francis','Saline','Scott','Searcy','Sebastian','Sevier','Sharp','Stone','Union','Van Buren','Washington','White','Woodruff','Yell'];

  case "US-CA":
  	return ['Alameda','Alpine','Amador','Butte','Calaveras','Colusa','Contra Costa','Del Norte','El Dorado','Fresno','Glenn','Humboldt','Imperial','Inyo','Kern','Kings','Lake','Lassen','Los Angeles','Madera','Marin','Mariposa','Mendocino','Merced','Modoc','Mono','Monterey','Napa','Nevada','Orange','Placer','Plumas','Riverside','Sacramento','San Benito','San Bernardino','San Diego','San Francisco','San Joaquin','San Luis Obispo','San Mateo','Santa Barbara','Santa Clara','Santa Cruz','Shasta','Sierra','Siskiyou','Solano','Sonoma','Stanislaus','Sutter','Tehama','Trinity','Tulare','Tuolumne','Ventura','Yolo','Yuba'];

  case "US-CO":
  	return ['Adams','Alamosa','Arapahoe','Archuleta','Baca','Bent','Boulder','Broomfield','Chaffee','Cheyenne','Clear Creek','Conejos','Costilla','Crowley','Custer','Delta','Denver','Dolores','Douglas','Eagle','Elbert','El Paso','Fremont','Garfield','Gilpin','Grand','Gunnison','Hinsdale','Huerfano','Jackson','Jefferson','Kiowa','Kit Carson','Lake','La Plata','Larimer','Las Animas','Lincoln','Logan','Mesa','Mineral','Moffat','Montezuma','Montrose','Morgan','Otero','Ouray','Park','Phillips','Pitkin','Prowers','Pueblo','Rio Blanco','Rio Grande','Routt','Saguache','San Juan','San Miguel','Sedgwick','Summit','Teller','Washington','Weld','Yuma'];

  case "US-CT":
  	return ['Fairfield','Hartford','Litchfield','Middlesex','New Haven','New London','Tolland','Windham'];

  case "US-DE":
  	return ['Kent','New Castle','Sussex'];

  case "US-FL":
  	return ['Alachua','Baker','Bay','Bradford','Brevard','Broward','Calhoun','Charlotte','Citrus','Clay','Collier','Columbia','DeSoto','Dixie','Duval','Escambia','Flagler','Franklin','Gadsden','Gilchrist','Glades','Gulf','Hamilton','Hardee','Hendry','Hernando','Highlands','Hillsborough','Holmes','Indian River','Jackson','Jefferson','Lafayette','Lake','Lee','Leon','Levy','Liberty','Madison','Manatee','Marion','Martin','Miami-Dade','Monroe','Nassau','Okaloosa','Okeechobee','Orange','Osceola','Palm Beach','Pasco','Pinellas','Polk','Putnam','St. Johns','St. Lucie','Santa Rosa','Sarasota','Seminole','Sumter','Suwannee','Taylor','Union','Volusia','Wakulla','Walton','Washington'];

  case "US-GA":
  	return ['Appling','Atkinson','Bacon','Baker','Baldwin','Banks','Barrow','Bartow','Ben Hill','Berrien','Bibb','Bleckley','Brantley','Brooks','Bryan','Bulloch','Burke','Butts','Calhoun','Camden','Candler','Carroll','Catoosa','Charlton','Chatham','Chattahoochee','Chattooga','Cherokee','Clarke','Clay','Clayton','Clinch','Cobb','Coffee','Colquitt','Columbia','Cook','Coweta','Crawford','Crisp','Dade','Dawson','De Kalb','Decatur','Dodge','Dooly','Dougherty','Douglas','Early','Echols','Effingham','Elbert','Emanuel','Evans','Fannin','Fayette','Floyd','Forsyth','Franklin','Fulton','Gilmer','Glascock','Glynn','Gordon','Grady','Greene','Gwinnett','Habersham','Hall','Hancock','Haralson','Harris','Hart','Heard','Henry','Houston','Irwin','Jackson','Jasper','Jeff Davis','Jefferson','Jenkins','Johnson','Jones','Lamar','Lanier','Laurens','Lee','Liberty','Lincoln','Long','Lowndes','Lumpkin','Macon','Madison','Marion','McDuffie','McIntosh','Meriwether','Miller','Mitchell','Monroe','Montgomery','Morgan','Murray','Muscogee','Newton','Oconee','Oglethorpe','Paulding','Peach','Pickens','Pierce','Pike','Polk','Pulaski','Putnam','Quitman','Rabun','Randolph','Richmond','Rockdale','Schley','Screven','Seminole','Spalding','Stephens','Stewart','Sumter','Talbot','Taliaferro','Tattnall','Taylor','Telfair','Terrell','Thomas','Tift','Toombs','Towns','Treutlen','Troup','Turner','Twiggs','Union','Upson','Walker','Walton','Ware','Warren','Washington','Wayne','Webster','Wheeler','White','Whitfield','Wilcox','Wilkes','Wilkinson','Worth'];

  case "US-HI":
  	return ['Hawaii','Honolulu','Kalawao','Kauai','Maui'];

  case "US-ID":
  	return ['Ada','Adams','Bannock','Bear Lake','Benewah','Bingham','Blaine','Boise','Bonner','Bonneville','Boundary','Butte','Camas','Canyon','Caribou','Cassia','Clark','Clearwater','Custer','Elmore','Franklin','Fremont','Gem','Gooding','Idaho','Jefferson','Jerome','Kootenai','Latah','Lemhi','Lewis','Lincoln','Madison','Minidoka','Nez Perce','Oneida','Owyhee','Payette','Power','Shoshone','Teton','Twin Falls','Valley','Washington'];

  case "US-IL":
  	return ['Adams','Alexander','Bond','Boone','Brown','Bureau','Calhoun','Carroll','Cass','Champaign','Christian','Clark','Clay','Clinton','Coles','Cook','Crawford','Cumberland','DeKalb','De Witt','Douglas','DuPage','Edgar','Edwards','Effingham','Fayette','Ford','Franklin','Fulton','Gallatin','Greene','Grundy','Hamilton','Hancock','Hardin','Henderson','Henry','Iroquois','Jackson','Jasper','Jefferson','Jersey','Jo Daviess','Johnson','Kane','Kankakee','Kendall','Knox','La Salle','Lake','Lawrence','Lee','Livingston','Logan','McDonough','McHenry','McLean','Macon','Macoupin','Madison','Marion','Marshall','Mason','Massac','Menard','Mercer','Monroe','Montgomery','Morgan','Moultrie','Ogle','Peoria','Perry','Piatt','Pike','Pope','Pulaski','Putnam','Randolph','Richland','Rock Island','Saline','Sangamon','Schuyler','Scott','Shelby','St. Clair','Stark','Stephenson','Tazewell','Union','Vermilion','Wabash','Warren','Washington','Wayne','White','Whiteside','Will','Williamson','Winnebago','Woodford'];

  case "US-IN":
  	return ['Adams','Allen','Bartholomew','Benton','Blackford','Boone','Brown','Carroll','Cass','Clark','Clay','Clinton','Crawford','Daviess','Dearborn','Decatur','De Kalb','Delaware','Dubois','Elkhart','Fayette','Floyd','Fountain','Franklin','Fulton','Gibson','Grant','Greene','Hamilton','Hancock','Harrison','Hendricks','Henry','Howard','Huntington','Jackson','Jasper','Jay','Jefferson','Jennings','Johnson','Knox','Kosciusko','La Porte','Lagrange','Lake','Lawrence','Madison','Marion','Marshall','Martin','Miami','Monroe','Montgomery','Morgan','Newton','Noble','Ohio','Orange','Owen','Parke','Perry','Pike','Porter','Posey','Pulaski','Putnam','Randolph','Ripley','Rush','St. Joseph','Scott','Shelby','Spencer','Starke','Steuben','Sullivan','Switzerland','Tippecanoe','Tipton','Union','Vanderburgh','Vermillion','Vigo','Wabash','Warren','Warrick','Washington','Wayne','Wells','White','Whitley'];

  case "US-IA":
  	return ['Adair','Adams','Allamakee','Appanoose','Audubon','Benton','Black Hawk','Boone','Bremer','Buchanan','Buena Vista','Butler','Calhoun','Carroll','Cass','Cedar','Cerro Gordo','Cherokee','Chickasaw','Clarke','Clay','Clayton','Clinton','Crawford','Dallas','Davis','Decatur','Delaware','Des Moines','Dickinson','Dubuque','Emmet','Fayette','Floyd','Franklin','Fremont','Greene','Grundy','Guthrie','Hamilton','Hancock','Hardin','Harrison','Henry','Howard','Humboldt','Ida','Iowa','Jackson','Jasper','Jefferson','Johnson','Jones','Keokuk','Kossuth','Lee','Linn','Louisa','Lucas','Lyon','Madison','Mahaska','Marion','Marshall','Mills','Mitchell','Monona','Monroe','Montgomery','Muscatine','O\'Brien','Osceola','Page','Palo Alto','Plymouth','Pocahontas','Polk','Pottawattamie','Poweshiek','Ringgold','Sac','Scott','Shelby','Sioux','Story','Tama','Taylor','Union','Van Buren','Wapello','Warren','Washington','Wayne','Webster','Winnebago','Winneshiek','Woodbury','Worth','Wright'];

  case "US-KS":
  	return ['Allen','Anderson','Atchison','Barber','Barton','Bourbon','Brown','Butler','Chase','Chautauqua','Cherokee','Cheyenne','Clark','Clay','Cloud','Coffey','Comanche','Cowley','Crawford','Decatur','Dickinson','Doniphan','Douglas','Edwards','Elk','Ellis','Ellsworth','Finney','Ford','Franklin','Geary','Gove','Graham','Grant','Gray','Greeley','Greenwood','Hamilton','Harper','Harvey','Haskell','Hodgeman','Jackson','Jefferson','Jewell','Johnson','Kearny','Kingman','Kiowa','Labette','Lane','Leavenworth','Lincoln','Linn','Logan','Lyon','Marion','Marshall','McPherson','Meade','Miami','Mitchell','Montgomery','Morris','Morton','Nemaha','Neosho','Ness','Norton','Osage','Osborne','Ottawa','Pawnee','Phillips','Pottawatomie','Pratt','Rawlins','Reno','Republic','Rice','Riley','Rooks','Rush','Russell','Saline','Scott','Sedgwick','Seward','Shawnee','Sheridan','Sherman','Smith','Stafford','Stanton','Stevens','Sumner','Thomas','Trego','Wabaunsee','Wallace','Washington','Wichita','Wilson','Woodson','Wyandotte'];

  case "US-KY":
  	return ['Adair','Allen','Anderson','Ballard','Barren','Bath','Bell','Boone','Bourbon','Boyd','Boyle','Bracken','Breathitt','Breckinridge','Bullitt','Butler','Caldwell','Calloway','Campbell','Carlisle','Carroll','Carter','Casey','Christian','Clark','Clay','Clinton','Crittenden','Cumberland','Daviess','Edmonson','Elliott','Estill','Fayette','Fleming','Floyd','Franklin','Fulton','Gallatin','Garrard','Grant','Graves','Grayson','Green','Greenup','Hancock','Hardin','Harlan','Harrison','Hart','Henderson','Henry','Hickman','Hopkins','Jackson','Jefferson','Jessamine','Johnson','Kenton','Knott','Knox','Larue','Laurel','Lawrence','Lee','Leslie','Letcher','Lewis','Lincoln','Livingston','Logan','Lyon','McCracken','McCreary','McLean','Madison','Magoffin','Marion','Marshall','Martin','Mason','Meade','Menifee','Mercer','Metcalfe','Monroe','Montgomery','Morgan','Muhlenberg','Nelson','Nicholas','Ohio','Oldham','Owen','Owsley','Pendleton','Perry','Pike','Powell','Pulaski','Robertson','Rockcastle','Rowan','Russell','Scott','Shelby','Simpson','Spencer','Taylor','Todd','Trigg','Trimble','Union','Warren','Washington','Wayne','Webster','Whitley','Wolfe','Woodford'];

  case "US-LA":
  	return ['Acadia','Allen','Ascension','Assumption','Avoyelles','Beauregard','Bienville','Bossier','Caddo','Calcasieu','Caldwell','Cameron','Catahoula','Claiborne','Concordia','De Soto','East Baton Rouge','East Carroll','East Feliciana','Evangeline','Franklin','Grant','Iberia','Iberville','Jackson','Jefferson','Jefferson Davis','La Salle','Lafayette','Lafourche','Lincoln','Livingston','Madison','Morehouse','Natchitoches','Orleans','Ouachita','Plaquemines','Pointe Coupee','Rapides','Red River','Richland','Sabine','St. Bernard','St. Charles','St. Helena','St. James','St. John The Baptist','St. Landry','St. Martin','St. Mary','St. Tammany','Tangipahoa','Tensas','Terrebonne','Union','Vermilion','Vernon','Washington','Webster','West Baton Rouge','West Carroll','West Feliciana','Winn'];

  case "US-ME":
  	return ['Androscoggin','Aroostook','Cumberland','Franklin','Hancock','Kennebec','Knox','Lincoln','Oxford','Penobscot','Piscataquis','Sagadahoc','Somerset','Waldo','Washington','York'];

  case "US-MD":
  	return ['Allegany','Anne Arundel','Baltimore','Baltimore City','Calvert','Caroline','Carroll','Cecil','Charles','Dorchester','Frederick','Garrett','Harford','Howard','Kent','Montgomery','Prince George\'s','Queen Anne\'s','St. Mary\'s','Somerset','Talbot','Washington','Wicomico','Worcester'];

  case "US-MA":
  	return ['Barnstable','Berkshire','Bristol','Dukes','Essex','Franklin','Hampden','Hampshire','Middlesex','Nantucket','Norfolk','Plymouth','Suffolk','Worcester'];

  case "US-MI":
  	return ['Alcona','Alger','Allegan','Alpena','Antrim','Arenac','Baraga','Barry','Bay','Benzie','Berrien','Branch','Calhoun','Cass','Charlevoix','Cheboygan','Chippewa','Clare','Clinton','Crawford','Delta','Dickinson','Eaton','Emmet','Genesee','Gladwin','Gogebic','Grand Traverse','Gratiot','Hillsdale','Houghton','Huron','Ingham','Ionia','Iosco','Iron','Isabella','Jackson','Kalamazoo','Kalkaska','Kent','Keweenaw','Lake','Lapeer','Leelanau','Lenawee','Livingston','Luce','Mackinac','Macomb','Manistee','Marquette','Mason','Mecosta','Menominee','Midland','Missaukee','Monroe','Montcalm','Montmorency','Muskegon','Newaygo','Oakland','Oceana','Ogemaw','Ontonagon','Osceola','Oscoda','Otsego','Ottawa','Presque Isle','Roscommon','Saginaw','St. Clair','St. Joseph','Sanilac','Schoolcraft','Shiawassee','Tuscola','Van Buren','Washtenaw','Wayne','Wexford'];

  case "US-MN":
  	return ['Aitkin','Anoka','Becker','Beltrami','Benton','Big Stone','Blue Earth','Brown','Carlton','Carver','Cass','Chippewa','Chisago','Clay','Clearwater','Cook','Cottonwood','Crow Wing','Dakota','Dodge','Douglas','Faribault','Fillmore','Freeborn','Goodhue','Grant','Hennepin','Houston','Hubbard','Isanti','Itasca','Jackson','Kanabec','Kandiyohi','Kittson','Koochiching','Lac Qui Parle','Lake','Lake Of The Wood','Le Sueur','Lincoln','Lyon','Mahnomen','Marshall','Martin','McLeod','Meeker','Mille Lacs','Morrison','Mower','Murray','Nicollet','Nobles','Norman','Olmsted','Otter Tail','Pennington','Pine','Pipestone','Polk','Pope','Ramsey','Red Lake','Redwood','Renville','Rice','Rock','Roseau','St. Louis','Scott','Sherburne','Sibley','Stearns','Steele','Stevens','Swift','Todd','Traverse','Wabasha','Wadena','Waseca','Washington','Watonwan','Wilkin','Winona','Wright','Yellow Medicine'];

  case "US-MS":
  	return ['Adams','Alcorn','Amite','Attala','Benton','Bolivar','Calhoun','Carroll','Chickasaw','Choctaw','Claiborne','Clarke','Clay','Coahoma','Copiah','Covington','De Soto','Forrest','Franklin','George','Greene','Grenada','Hancock','Harrison','Hinds','Holmes','Humphreys','Issaquena','Itawamba','Jackson','Jasper','Jefferson','Jefferson Davis','Jones','Kemper','Lafayette','Lamar','Lauderdale','Lawrence','Leake','Lee','Leflore','Lincoln','Lowndes','Madison','Marion','Marshall','Monroe','Montgomery','Neshoba','Newton','Noxubee','Oktibbeha','Panola','Pearl River','Perry','Pike','Pontotoc','Prentiss','Quitman','Rankin','Scott','Sharkey','Simpson','Smith','Stone','Sunflower','Tallahatchie','Tate','Tippah','Tishomingo','Tunica','Union','Walthall','Warren','Washington','Wayne','Webster','Wilkinson','Winston','Yalobusha','Yazoo'];

  case "US-MO":
  	return ['Adair','Andrew','Atchison','Audrain','Barry','Barton','Bates','Benton','Bollinger','Boone','Buchanan','Butler','Caldwell','Callaway','Camden','Cape Girardeau','Carroll','Carter','Cass','Cedar','Chariton','Christian','Clark','Clay','Clinton','Cole','Cooper','Crawford','Dade','Dallas','Daviess','De Kalb','Dent','Douglas','Dunklin','Franklin','Gasconade','Gentry','Greene','Grundy','Harrison','Henry','Hickory','Holt','Howard','Howell','Iron','Jackson','Jasper','Jefferson','Johnson','Knox','Laclede','Lafayette','Lawrence','Lewis','Lincoln','Linn','Livingston','Macon','Madison','Maries','Marion','McDonal1d','Mercer','Miller','Mississippi','Moniteau','Monroe','Montgomery','Morgan','New Madrid','Newton','Nodaway','Oregon','Osage','Ozark','Pemiscot','Perry','Pettis','Phelps','Pike','Platte','Polk','Pulaski','Putnam','Ralls','Randolph','Ray','Reynolds','Ripley','St. Charles','St. Clair','Ste. Genevieve','St. Francois','St. Louis','St. Louis City','Saline','Schuyler','Scotland','Scott','Shannon','Shelby','Stoddard','Stone','Sullivan','Taney','Texas','Vernon','Warren','Washington','Wayne','Webster','Worth','Wright'];

  case "US-MT":
  	return ['Beaverhead','Big Horn','Blaine','Broadwater','Carbon','Carter','Cascade','Chouteau','Custer','Daniels','Dawson','Deer Lodge','Fallon','Fergus','Flathead','Gallatin','Garfield','Glacier','Golden Valley','Granite','Hill','Jefferson','Judith Basin','Lake','Lewis And Clark','Liberty','Lincoln','Madison','McCone','Meagher','Mineral','Missoula','Musselshell','Park','Petroleum','Phillips','Pondera','Powder River','Powell','Prairie','Ravalli','Richland','Roosevelt','Rosebud','Sanders','Sheridan','Silver Bow','Stillwater','Sweet Grass','Teton','Toole','Treasure','Valley','Wheatland','Wibaux','Yellowstone','Yellowstone National Park'];

  case "US-NE":
  	return ['Adams','Antelope','Arthur','Banner','Blaine','Boone','Box Butte','Boyd','Brown','Buffalo','Burt','Butler','Cass','Cedar','Chase','Cherry','Cheyenne','Clay','Colfax','Cuming','Custer','Dakota','Dawes','Dawson','Deuel','Dixon','Dodge','Douglas','Dundy','Fillmore','Franklin','Frontier','Furnas','Gage','Garden','Garfield','Gosper','Grant','Greeley','Hall','Hamilton','Harlan','Hayes','Hitchcock','Holt','Hooker','Howard','Jefferson','Johnson','Kearney','Keith','Keya Paha','Kimball','Knox','Lancaster','Lincoln','Logan','Loup','McPherson','Madison','Merrick','Morrill','Nance','Nemaha','Nuckolls','Otoe','Pawnee','Perkins','Phelps','Pierce','Platte','Polk','Red Willow','Richardson','Rock','Saline','Sarpy','Saunders','Scotts Bluff','Seward','Sheridan','Sherman','Sioux','Stanton','Thayer','Thomas','Thurston','Valley','Washington','Wayne','Webster','Wheeler','York'];

  case "US-NV":
  	return ['Carson City','Churchill','Clark','Douglas','Elko','Esmeralda','Eureka','Humboldt','Lander','Lincoln','Lyon','Mineral','Nye','Pershing','Storey','Washoe','White Pine'];

  case "US-NH":
  	return ['Belknap','Carroll','Cheshire','Coos','Grafton','Hillsborough','Merrimack','Rockingham','Strafford','Sullivan'];

  case "US-NJ":
  	return ['Atlantic','Bergen','Burlington','Camden','Cape May','Cumberland','Essex','Gloucester','Hudson','Hunterdon','Mercer','Middlesex','Monmouth','Morris','Ocean','Passaic','Salem','Somerset','Sussex','Union','Warren'];

  case "US-NM":
  	return ['Bernalillo','Catron','Chaves','Cibola','Colfax','Curry','De Baca','Dona Ana','Eddy','Grant','Guadalupe','Harding','Hidalgo','Lea','Lincoln','Los Alamos','Luna','McKinley','Mora','Otero','Quay','Rio Arriba','Roosevelt','Sandoval','San Juan','San Miguel','Santa Fe','Sierra','Socorro','Taos','Torrance','Union','Valencia'];

  case "US-NY":
  	return ['Albany','Allegany','Bronx','Broome','Cattaraugus','Cayuga','Chautauqua','Chemung','Chenango','Clinton','Columbia','Cortland','Delaware','Dutchess','Erie','Essex','Franklin','Fulton','Genesee','Greene','Hamilton','Herkimer','Jefferson','Kings','Lewis','Livingston','Madison','Monroe','Montgomery','Nassau','New York City','Niagara','Oneida','Onondaga','Ontario','Orange','Orleans','Oswego','Otsego','Putnam','Queens','Rensselaer','Richmond','Rockland','St. Lawrence','Saratoga','Schenectady','Schoharie','Schuyler','Seneca','Steuben','Suffolk','Sullivan','Tioga','Tompkins','Ulster','Warren','Washington','Wayne','Westchester','Wyoming','Yates'];

  case "US-NC":
  	return ['Alamance','Alexander','Alleghany','Anson','Ashe','Avery','Beaufort','Bertie','Bladen','Brunswick','Buncombe','Burke','Cabarrus','Caldwell','Camden','Carteret','Caswell','Catawba','Chatham','Cherokee','Chowan','Clay','Cleveland','Columbus','Craven','Cumberland','Currituck','Dare','Davidson','Davie','Duplin','Durham','Edgecombe','Forsyth','Franklin','Gaston','Gates','Graham','Granville','Greene','Guilford','Halifax','Harnett','Haywood','Henderson','Hertford','Hoke','Hyde','Iredell','Jackson','Johnston','Jones','Lee','Lenoir','Lincoln','McDowell','Macon','Madison','Martin','Mecklenburg','Mitchell','Montgomery','Moore','Nash','New Hanover','Northampton','Onslow','Orange','Pamlico','Pasquotank','Pender','Perquimans','Person','Pitt','Polk','Randolph','Richmond','Robeson','Rockingham','Rowan','Rutherford','Sampson','Scotland','Stanly','Stokes','Surry','Swain','Transylvania','Tyrrell','Union','Vance','Wake','Warren','Washington','Watauga','Wayne','Wilkes','Wilson','Yadkin','Yancey'];

  case "US-ND":
  	return ['Adams','Barnes','Benson','Billings','Bottineau','Bowman','Burke','Burleigh','Cass','Cavalier','Dickey','Divide','Dunn','Eddy','Emmons','Foster','Golden Valley','Grand Forks','Grant','Griggs','Hettinger','Kidder','LaMoure','Logan','McHenry','McIntosh','McKenzie','McLean','Mercer','Morton','Mountrail','Nelson','Oliver','Pembina','Pierce','Ramsey','Ransom','Renville','Richland','Rolette','Sargent','Sheridan','Sioux','Slope','Stark','Steele','Stutsman','Towner','Traill','Walsh','Ward','Wells','Williams'];

  case "US-OH":
  	return ['Adams','Allen','Ashland','Ashtabula','Athens','Auglaize','Belmont','Brown','Butler','Carroll','Champaign','Clark','Clermont','Clinton','Columbiana','Coshocton','Crawford','Cuyahoga','Darke','Defiance','Delaware','Erie','Fairfield','Fayette','Franklin','Fulton','Gallia','Geauga','Greene','Guernsey','Hamilton','Hancock','Hardin','Harrison','Henry','Highland','Hocking','Holmes','Huron','Jackson','Jefferson','Knox','Lake','Lawrence','Licking','Logan','Lorain','Lucas','Madison','Mahoning','Marion','Medina','Meigs','Mercer','Miami','Monroe','Montgomery','Morgan','Morrow','Muskingum','Noble','Ottawa','Paulding','Perry','Pickaway','Pike','Portage','Preble','Putnam','Richland','Ross','Sandusky','Scioto','Seneca','Shelby','Stark','Summit','Trumbull','Tuscarawas','Union','Van Wert','Vinton','Warren','Washington','Wayne','Williams','Wood','Wyandot'];

  case "US-OK":
  	return ['Adair','Alfalfa','Atoka','Beaver','Beckham','Blaine','Bryan','Caddo','Canadian','Carter','Cherokee','Choctaw','Cimarron','Cleveland','Coal','Comanche','Cotton','Craig','Creek','Custer','Delaware','Dewey','Ellis','Garfield','Garvin','Grady','Grant','Greer','Harmon','Harper','Haskell','Hughes','Jackson','Jefferson','Johnston','Kay','Kingfisher','Kiowa','Latimer','Le Flore','Lincoln','Logan','Love','McClain','McCurtain','McIntosh','Major','Marshall','Mayes','Murray','Muskogee','Noble','Nowata','Okfuskee','Oklahoma','Okmulgee','Osage','Ottawa','Pawnee','Payne','Pittsburg','Pontotoc','Pottawatomie','Pushmataha','Roger Mills','Rogers','Seminole','Sequoyah','Stephens','Texas','Tillman','Tulsa','Wagoner','Washington','Washita','Woods','Woodward'];

  case "US-OR":
  	return ['Baker','Benton','Clackamas','Clatsop','Columbia','Coos','Crook','Curry','Deschutes','Douglas','Gilliam','Grant','Harney','Hood River','Jackson','Jefferson','Josephine','Klamath','Lake','Lane','Lincoln','Linn','Malheur','Marion','Morrow','Multnomah','Polk','Sherman','Tillamook','Umatilla','Union','Wallowa','Wasco','Washington','Wheeler','Yamhill'];

  case "US-PA":
  	return ['Adams','Allegheny','Armstrong','Beaver','Bedford','Berks','Blair','Bradford','Bucks','Butler','Cambria','Cameron','Carbon','Centre','Chester','Clarion','Clearfield','Clinton','Columbia','Crawford','Cumberland','Dauphin','Delaware','Elk','Erie','Fayette','Forest','Franklin','Fulton','Greene','Huntingdon','Indiana','Jefferson','Juniata','Lackawanna','Lancaster','Lawrence','Lebanon','Lehigh','Luzerne','Lycoming','McKean','Mercer','Mifflin','Monroe','Montgomery','Montour','Northampton','Northumberland','Perry','Philadelphia','Pike','Potter','Schuylkill','Snyder','Somerset','Sullivan','Susquehanna','Tioga','Union','Venango','Warren','Washington','Wayne','Westmoreland','Wyoming','York'];

  case "US-RI":
  	return ['Bristol','Kent','Newport','Providence','Washington'];

  case "US-SC":
  	return ['Abbeville','Aiken','Allendale','Anderson','Bamberg','Barnwell','Beaufort','Berkeley','Calhoun','Charleston','Cherokee','Chester','Chesterfield','Clarendon','Colleton','Darlington','Dillon','Dorchester','Edgefield','Fairfield','Florence','Georgetown','Greenville','Greenwood','Hampton','Horry','Jasper','Kershaw','Lancaster','Laurens','Lee','Lexington','McCormick','Marion','Marlboro','Newberry','Oconee','Orangeburg','Pickens','Richland','Saluda','Spartanburg','Sumter','Union','Williamsburg','York'];

  case "US-SD":
  	return ['Aurora','Beadle','Bennett','Bon Homme','Brookings','Brown','Brule','Buffalo','Butte','Campbell','Charles Mix','Clark','Clay','Codington','Corson','Custer','Davison','Day','Deuel','Dewey','Douglas','Edmunds','Fall River','Faulk','Grant','Gregory','Haakon','Hamlin','Hand','Hanson','Harding','Hughes','Hutchinson','Hyde','Jackson','Jerauld','Jones','Kingsbury','Lake','Lawrence','Lincoln','Lyman','McCook','McPherson','Marshall','Meade','Mellette','Miner','Minnehaha','Moody','Pennington','Perkins','Potter','Roberts','Sanborn','Shannon','Spink','Stanley','Sully','Todd','Tripp','Turner','Union','Walworth','Yankton','Ziebach'];

  case "US-TN":
  	return ['Anderson','Bedford','Benton','Bledsoe','Blount','Bradley','Campbell','Cannon','Carroll','Carter','Cheatham','Chester','Claiborne','Clay','Cocke','Coffee','Crockett','Cumberland','Davidson','Decatur','DeKalb','Dickson','Dyer','Fayette','Fentress','Franklin','Gibson','Giles','Grainger','Greene','Grundy','Hamblen','Hamilton','Hancock','Hardeman','Hardin','Hawkins','Haywood','Henderson','Henry','Hickman','Houston','Humphreys','Jackson','Jefferson','Johnson','Knox','Lake','Lauderdale','Lawrence','Lewis','Lincoln','Loudon','McMinn','McNairy','Macon','Madison','Marion','Marshall','Maury','Meigs','Monroe','Montgomery','Moore','Morgan','Obion','Overton','Perry','Pickett','Polk','Putnam','Rhea','Roane','Robertson','Rutherford','Scott','Sequatchie','Sevier','Shelby','Smith','Stewart','Sullivan','Sumner','Tipton','Trousdale','Unicoi','Union','Van Buren','Warren','Washington','Wayne','Weakley','White','Williamson','Wilson'];

  case "US-TX":
  	return ['Anderson','Andrews','Angelina','Aransas','Archer','Armstrong','Atascosa','Austin','Bailey','Bandera','Bastrop','Baylor','Bee','Bell','Bexar','Blanco','Borden','Bosque','Bowie','Brazoria','Brazos','Brewster','Briscoe','Brooks','Brown','Burleson','Burnet','Caldwell','Calhoun','Callahan','Cameron','Camp','Carson','Cass','Castro','Chambers','Cherokee','Childress','Clay','Cochran','Coke','Coleman','Collin','Collingsworth','Colorado','Comal','Comanche','Concho','Cooke','Coryell','Cottle','Crane','Crockett','Crosby','Culberson','Dallam','Dallas','Dawson','Deaf Smith','Delta','Denton','DeWitt','Dickens','Dimmit','Donley','Duval','Eastland','Ector','Edwards','Ellis','El Paso','Erath','Falls','Fannin','Fayette','Fisher','Floyd','Foard','Fort Bend','Franklin','Freestone','Frio','Gaines','Galveston','Garza','Gillespie','Glasscock','Goliad','Gonzales','Gray','Grayson','Gregg','Grimes','Guadalupe','Hale','Hall','Hamilton','Hansford','Hardeman','Hardin','Harris','Harrison','Hartley','Haskell','Hays','Hemphill','Henderson','Hidalgo','Hill','Hockley','Hood','Hopkins','Houston','Howard','Hudspeth','Hunt','Hutchinson','Irion','Jack','Jackson','Jasper','Jeff Davis','Jefferson','Jim Hogg','Jim Wells','Johnson','Jones','Karnes','Kaufman','Kendall','Kenedy','Kent','Kerr','Kimble','King','Kinney','Kleberg','Knox','Lamar','Lamb','Lampasas','La Salle','Lavaca','Lee','Leon','Liberty','Limestone','Lipscomb','Live Oak','Llano','Loving','Lubbock','Lynn','McCulloch','McLennan','McMullen','Madison','Marion','Martin','Mason','Matagorda','Maverick','Medina','Menard','Midland','Milam','Mills','Mitchell','Montague','Montgomery','Moore','Morris','Motley','Nacogdoches','Navarro','Newton','Nolan','Nueces','Ochiltree','Oldham','Orange','Palo Pinto','Panola','Parker','Parmer','Pecos','Polk','Potter','Presidio','Rains','Randall','Reagan','Real','Red River','Reeves','Refugio','Roberts','Robertson','Rockwall','Runnels','Rusk','Sabine','San Augustine','San Jacinto','San Patricio','San Saba','Schleicher','Scurry','Shackelford','Shelby','Sherman','Smith','Somervell','Starr','Stephens','Sterling','Stonewall','Sutton','Swisher','Tarrant','Taylor','Terrell','Terry','Throckmorton','Titus','Tom Green','Travis','Trinity','Tyler','Upshur','Upton','Uvalde','Val Verde','Van Zandt','Victoria','Walker','Waller','Ward','Washington','Webb','Wharton','Wheeler','Wichita','Wilbarger','Willacy','Williamson','Wilson','Winkler','Wise','Wood','Yoakum','Young','Zapata','Zavala'];

  case "US-UT":
  	return ['Beaver','Box Elder','Cache','Carbon','Daggett','Davis','Duchesne','Emery','Garfield','Grand','Iron','Juab','Kane','Millard','Morgan','Piute','Rich','Salt Lake','San Juan','Sanpete','Sevier','Summit','Tooele','Uintah','Utah','Wasatch','Washington','Wayne','Weber'];

  case "US-VT":
  	return ['Addison','Bennington','Caledonia','Chittenden','Essex','Franklin','Grand Isle','Lamoille','Orange','Orleans','Rutland','Washington','Windham','Windsor'];

  case "US-VA":
  	return ['Accomack','Albemarle','Alleghany','Amelia','Amherst','Appomattox','Arlington','Augusta','Bath','Bedford','Bland','Botetourt','Brunswick','Buchanan','Buckingham','Campbell','Caroline','Carroll','Charles City','Charlotte','Chesterfield','Clarke','Craig','Culpeper','Cumberland','Dickenson','Dinwiddie','Essex','Fairfax','Fauquier','Floyd','Fluvanna','Franklin','Frederick','Giles','Gloucester','Goochland','Grayson','Greene','Greensville','Halifax','Hanover','Henrico','Henry','Highland','Isle Of Wight','James City','King And Queen','King George','King William','Lancaster','Lee','Loudoun','Louisa','Lunenburg','Madison','Mathews','Mecklenburg','Middlesex','Montgomery','Nelson','New Kent','Northampton','Northumberland','Nottoway','Orange','Page','Patrick','Pittsylvania','Powhatan','Prince Edward','Prince George','Prince William','Pulaski','Rappahannock','Richmond','Roanoke','Rockbridge','Rockingham','Russell','Scott','Shenandoah','Smyth','Southampton','Spotsylvania','Stafford','Surry','Sussex','Tazewell','Warren','Washington','Westmoreland','Wise','Wythe','York'];

  case "US-WA":
  	return ['Adams','Asotin','Benton','Chelan','Clallam','Clark','Columbia','Cowlitz','Douglas','Ferry','Franklin','Garfield','Grant','Grays Harbor','Island','Jefferson','King','Kitsap','Kittitas','Klickitat','Lewis','Lincoln','Mason','Okanogan','Pacific','Pend Oreille','Pierce','San Juan','Skagit','Skamania','Snohomish','Spokane','Stevens','Thurston','Wahkiakum','Walla Walla','Whatcom','Whitman','Yakima'];

  case "US-WI":
  	return ['Adams','Ashland','Barron','Bayfield','Brown','Buffalo','Burnett','Calumet','Chippewa','Clark','Columbia','Crawford','Dane','Dodge','Door','Douglas','Dunn','Eau Claire','Florence','Fond Du Lac','Forest','Grant','Green','Green Lake','Iowa','Iron','Jackson','Jefferson','Juneau','Kenosha','Kewaunee','La Crosse','Lafayette','Langlade','Lincoln','Manitowoc','Marathon','Marinette','Marquette','Menominee','Milwaukee','Monroe','Oconto','Oneida','Outagamie','Ozaukee','Pepin','Pierce','Polk','Portage','Price','Racine','Richland','Rock','Rusk','St. Croix','Sauk','Sawyer','Shawano','Sheboygan','Taylor','Trempealeau','Vernon','Vilas','Walworth','Washburn','Washington','Waukesha','Waupaca','Waushara','Winnebago','Wood'];

  case "US-WV":
  	return ['Barbour','Berkeley','Boone','Braxton','Brooke','Cabell','Calhoun','Clay','Doddridge','Fayette','Gilmer','Grant','Greenbrier','Hampshire','Hancock','Hardy','Harrison','Jackson','Jefferson','Kanawha','Lewis','Lincoln','Logan','McDowell','Marion','Marshall','Mason','Mercer','Mineral','Mingo','Monongalia','Monroe','Morgan','Nicholas','Ohio','Pendleton','Pleasants','Pocahontas','Preston','Putnam','Raleigh','Randolph','Ritchie','Roane','Summers','Taylor','Tucker','Tyler','Upshur','Wayne',
    'Webster','Wetzel','Wirt','Wood','Wyoming'];

  case "US-WY":
  	return ['Albany','Big Horn','Campbell','Carbon','Converse','Crook','Fremont','Goshen','Hot Springs','Johnson','Laramie','Lincoln','Natrona','Niobrara','Park','Platte','Sheridan','Sublette','Sweetwater','Teton','Uinta','Washakie','Weston'];

  default:

  }
}
else
{
  return [];
}

}

function validPreviousDatesForChronology(attibuteName)
{
  switch (attibuteName)
  {
    case 'FireIgnitionDateTime':
        return [];

    case 'FireDiscoveryDateTime':
        return ["FireIgnitionDateTime"];

    case 'InitialResponseDateTime':
        return ["FireDiscoveryDateTime", "FireIgnitionDateTime"];

    case 'EstimatedContainmentDate':
        return ["InitialResponseDateTime", "FireDiscoveryDateTime", "FireIgnitionDateTime"];

    case 'ContainmentDateTime':
          return ["InitialResponseDateTime", "FireDiscoveryDateTime", "FireIgnitionDateTime"];

    case 'FireGrowthCessationDateTime':
      return ["ContainmentDateTime", "InitialResponseDateTime", "FireDiscoveryDateTime", "FireIgnitionDateTime"];

    case 'ControlDateTime':
      return ["FireGrowthCessationDateTime", "ContainmentDateTime", "InitialResponseDateTime", "FireDiscoveryDateTime", "FireIgnitionDateTime"];

    case 'FireOutDateTime':
        return ["ControlDateTime", "FireGrowthCessationDateTime", "ContainmentDateTime", "InitialResponseDateTime", "FireDiscoveryDateTime", "FireIgnitionDateTime"];

    case 'FinalStrategyAttainedDateTime':
        return ["ControlDateTime", "FireGrowthCessationDateTime", "ContainmentDateTime", "InitialResponseDateTime", "FireDiscoveryDateTime", "FireIgnitionDateTime"];

    default:
      return [];
  }
}
export function getDefaultDateForField(attributeName, attributes)
{
  let previousChronologyItems = validPreviousDatesForChronology(attributeName);
  if (previousChronologyItems.length === 0)
  {
    return new Date();
  }

  for (const item of previousChronologyItems)
  {
    if (attributes[item] !== null && attributes[item] !== '')
    {
      return new Date(attributes[item]);
    }
  }

  return new Date();
}

export function getDependentAttributeMapping(dependentAttibuteName, dependentAttributeValue)
{
    if (dependentAttibuteName === originFields.incidentTypeKind)
    {
      switch (dependentAttributeValue)
      {
        case 'FI':
          return ["DF", "NS", "RX", "SF", "VF", "WF", "GF", "IM"];
        case 'FM':
            return ["BR", "FA", "FR", "CX", "SU", "OR", "PP"];
        case 'HZ':
          return ["BI", "FG", "EX", "RD"];
        case 'AC':
          return ["AI", "MV", "RA", "MR", "ST"];
        case 'AP':
          return ["RP", "LE", "MG"];
        case 'PA':
          return  ["CM", "PS", "IN"];
        case 'SR':
          return  ["UR", "WL", "MN", "MA"];
        case 'ND':
          return  ["EQ", "FL", "HU", "LS", "TS", "TU", "VO", "WW"];
        case 'TR':
          return  ["CT", "JT", "PC", "SI"];
        default:
          return [];
      }
    }

    if (dependentAttibuteName === originFields.landownerKind)
    {
      switch (dependentAttributeValue)
      {
        case 'Federal':
          return ["BIA", "BLM", "BOR", "DOD", "DOE", "NPS", "USFS", "USFWS", "RX", "SF", "VF", "WF"];
        case 'Other':
          return ["Foreign", "Tribal", "City", "County", "State"];
        case 'Private':
          return ["Private", "ANCSA"];
        default:
          return [];
      }
    }

    if (dependentAttibuteName === originFields.fireCause)
    {
      switch (dependentAttributeValue)
      {
        case 'Human':
          return ["Camping", "Smoking", "Incendiary", "Equipment", "Utilities", "Firearms/Weapons", "Debris/Open Burning", "Other Human Cause", "Railroad"];
        case 'Natural':
          return ["Other Natural Cause", "Coal Seam", "Lightning", "Volcanic"];
        case 'Undetermined':
          return ["Undetermined"];
        default:
          return [];
      }
    }

    //Start here
    if (dependentAttibuteName === originFields.combustionFuelGroup)
        {
          switch (dependentAttributeValue)
          {
            case 'Ground':
              return ["Peat", "Tundra", "Coal seam", "Deep duff"];
            case 'Surface':
              return ["Grass", "Shrub", "Timber", "Slash", "Heavy fuel loading", "Jackpots"];
            case 'Aerial':      
              return ["Sustained Crown Fire", "Stressed/dead Foliage", "Heavy ladder fuels"];
            default:
              return [];
          }
        }
        ///End here
  if (dependentAttibuteName === originFields.predominantFuelGroup)
        {
          switch (dependentAttributeValue)
          {
            case 'Grass':
              return ["GR1", "GR2", "GR3", "GR4", "GR5", "GR6", "GR7", "GR8", "GR9"];
            case 'Grass-Shrub':
              return ["GS1", "GS2", "GS3", "GS4"];
            case 'Shrub':
            case 'Brush':      
              return ["SH1", "SH2", "SH3", "SH4", "SH5", "SH6", "SH7", "SH8", "SH9"];
            case 'Timber':
              return ["TU1", "TU2", "TU3", "TU4", "TU5", "TL1", "TL2", "TL3", "TL4", "TL5", "TL6", "TL7", "TL8", "TL9"];
            case 'Slash':
              return ["SB1", "SB2", "SB3", "SB4"];
            case 'Nonburnable':
                return ["NB1", "NB2", "NB3", "NB8", "NB9"];
            default:
              return [];
          }
        }
}

export function getLandownerKindFromSMACategory(category)
{
  const federals = [
    'BIA',
    'BLM',
    'BOR',
    'DOD',
    'DOE',
    'NPS',
    'USFS',
    'USFWS'
];

if (federals.includes(category))
{
    return 'Federal';
}

return (category === 'Private') ? 'Private' : 'Other';
}

export function getLandownerCategoryFromSMA(adminAgencyCode)
{
    switch (adminAgencyCode)
    {
      case 'PVT':
        return 'Private';

      case 'USBR':
        return 'BOR';

      case 'FWS':
          return 'USFWS';

      case 'ST':
          return 'State';

        default:
          return adminAgencyCode;
    }
}
export function getFuelFromCode(fuelModelCode)
{
  /*
  -9999	Fill-NoData
c
*/
switch (fuelModelCode) {
  case "91":
    return	{FuelGroup: "Nonburnable", FuelModel: "NB1"}
  case "92":
    return	{FuelGroup: "Nonburnable", FuelModel: "NB2"}
  case "93":
    return	{FuelGroup: "Nonburnable", FuelModel: "NB3"}
  case "98":
    return	{FuelGroup: "Nonburnable", FuelModel: "NB8"}
  case "99":
    return	{FuelGroup: "Nonburnable", FuelModel: "NB9"}
  case "101":
    return	{FuelGroup: "Grass", FuelModel: "GR1"}
  case "102":
    return	{FuelGroup: "Grass", FuelModel: "GR2"}
  case "103":
    return	{FuelGroup: "Grass", FuelModel: "GR3"}
  case "104":
    return	{FuelGroup: "Grass", FuelModel: "GR4"}
  case "105":
    return	{FuelGroup: "Grass", FuelModel: "GR5"}
  case "106":
    return	{FuelGroup: "Grass", FuelModel: "GR6"}
  case "107":
    return	{FuelGroup: "Grass", FuelModel: "GR7"}
  case "108":
    return	{FuelGroup: "Grass", FuelModel: "GR8"}
  case "109":
    return	{FuelGroup: "Grass", FuelModel: "GR9"}
  case "121":
    return	{FuelGroup: "Grass-Shrub", FuelModel: "GS1"}
  case "122":
    return	{FuelGroup: "Grass-Shrub", FuelModel: "GS2"}
  case "123":
    return	{FuelGroup: "Grass-Shrub", FuelModel: "GS3"}
  case "124":
    return	{FuelGroup: "Grass-Shrub", FuelModel: "GS4"}
  case "141":
    return	{FuelGroup: "Brush", FuelModel: "SH1"}
  case "142":
    return	{FuelGroup: "Brush", FuelModel: "SH2"}
  case "143":
    return	{FuelGroup: "Brush", FuelModel: "SH3"}
  case "144":
    return	{FuelGroup: "Brush", FuelModel: "SH4"}
  case "145":
    return	{FuelGroup: "Brush", FuelModel: "SH5"}
  case "146":
    return	{FuelGroup: "Brush", FuelModel: "SH6"}
  case "147":
    return	{FuelGroup: "Brush", FuelModel: "SH7"}
  case "148":
    return	{FuelGroup: "Brush", FuelModel: "SH8"}
  case "149":
    return	{FuelGroup: "Brush", FuelModel: "SH9"}
  case "161":
    return	{FuelGroup: "Timber", FuelModel: "TU1"}
  case "162":
    return	{FuelGroup: "Timber", FuelModel: "TU2"}
  case "163":
    return	{FuelGroup: "Timber", FuelModel: "TU3"}
  case "164":
    return	{FuelGroup: "Timber", FuelModel: "TU4"}
  case "165":
    return	{FuelGroup: "Timber", FuelModel: "TU5"}
  case "181":
    return	{FuelGroup: "Timber", FuelModel: "TL1"}
  case "182":
    return	{FuelGroup: "Timber", FuelModel: "TL2"}
  case "183":
    return	{FuelGroup: "Timber", FuelModel: "TL3"}
  case "184":
    return	{FuelGroup: "Timber", FuelModel: "TL4"}
  case "185":
    return	{FuelGroup: "Timber", FuelModel: "TL5"}
  case "186":
    return	{FuelGroup: "Timber", FuelModel: "TL6"}
  case "187":
    return	{FuelGroup: "Timber", FuelModel: "TL7"}
  case "188":
    return	{FuelGroup: "Timber", FuelModel: "TL8"}
  case "189":
    return	{FuelGroup: "Timber", FuelModel: "TL9"}
  case "201":
    return	{FuelGroup: "Slash", FuelModel: "SB1"}
  case "202":
    return	{FuelGroup: "Slash", FuelModel: "SB2"}
  case "203":
    return	{FuelGroup: "Slash", FuelModel: "SB3"}
  case "204":
    return	{FuelGroup: "Slash", FuelModel: "SB4"}
  default:
    return	{FuelGroup: "", FuelModel: ""}
}
  /*if  (["GR1", "GR2", "GR3", "GR4", "GR5", "GR6", "GR7", "GR8", "GR9"].includes(fuelModel))
  {
      return 'Grass';
  }

  if (["GS1", "GS2", "GS3", "GS4"].includes(fuelModel)) {
    return 'Grass-Shrub';
  }

  if (["SH1", "SH2", "SH3", "SH4", "SH5", "SH6", "SH7", "SH8", "SH9"].includes(fuelModel)) {
      return 'Brush';
  }

  if (["TU1", "TU2", "TU3", "TU4", "TU5", "TL1", "TL2", "TL3", "TL4", "TL5", "TL6", "TL7", "TL8", "TL9"].includes(fuelModel)) {
    return  'Timber';
  }

  if (["SB1", "SB2", "SB3", "SB4"].includes(fuelModel)) {
    return 'Slash';
  }

  if (["NB1", "NB2", "NB3", "NB8", "NB9"].includes(fuelModel)) {
    return 'Nonburnable';
  }

  return ''; */
}
//TODO: IMH: Throw this into JSON / Map or something.
export function getFieldAliasOverrides(field)
{
  if (field === undefined || field === null) {
    return "";
  }
  
  if (field.name === originFields.landownerKind)
  {
    return "Landowner Kind";
  }

  if (field.name === originFields.gacc)
  {
    return "Geographic Area Coordination Center Code";
  }

  if (field.name === originFields.uniqueFireId)
  {
    return "Unique Fire Identifier";
  }

  if (field.name === originFields.informUserName)
  {
    return "InFORM User Name";
  }

  if (field.name === originFields.fsJobCode)
  {
    return "USFS Job Code Prefix";
  }

  if (field.name === originFields.fireCode)
  {
    return "FireCode";
  }

  if (field.name === originFields.finalFireReportApprovedDate)
  {
    return "Certified Date Time";
  }

  if (field.name === originFields.finalFireReportApprovedBy)
  {
    return "Certified By";
  }

  if (field.name === originFields.incidentTypeKind)
  {
    return "Incident Type";
  }

  if (field.name === originFields.landownerCategory)
  {
    return "Landowner Category";
  }

  if (field.name === originFields.incidentTypeCategory)
  {
    return "Incident Category";
  }

  if (field.name === originFields.state)
  {
    return "State";
  }

  if (field.name === originFields.county)
  {
    return "County";
  }

  if (field.name === originFields.dispatchCenterId)
  {
    return "Dispatch Center ID";
  }

  if (field.name === originFields.pooDispatchCenterID)
  {
    return "Derived Dispatch Center ID";
  }


  if (field.name === originFields.incidentJurisdictionalAgency)
  {
    return "Jurisdictional Agency";
  }

  if (field.name === originFields.jurisdictionalUnit)
  {
    return "Jurisdictional Unit";
  }

  if (field.name === originFields.pooProtectingAgency)
  {
    return "Protecting Agency";
  }

  if (field.name === originFields.pooProtectingUnit)
  {
    return "Protecting Unit";
  }

  if (field.name === originFields.fireDepartmentId)
  {
    return "Protecting Fire Dept ID";
  }

  if (field.name === originFields.jurisdictionalUnitParentUnit)
  {
    return "Juris. Parent Unit";
  }

  if (field.name === originFields.predominantFuelGroup)
  {
    return "Fuel Group";
  }

  if (field.name === originFields.predominantFuelModel)
  {
    return "Fuel Model";
  }

  if (field.name === originFields.fireIgnitionDate)
  {
    return "Ignition";
  }

  if (field.name === originFields.fireGrowthCessationDate)
  {
    return "Growth Cessation";
  }

  if (field.name === originFields.discoveryDate)
  {
    return "Discovery";
  }

  if (field.name === originFields.initialResponseDate)
  {
    return "Initial Response";
  }

  if (field.name === originFields.containmentDate)
  {
    return "Containment";
  }

  if (field.name === originFields.controlDate)
  {
    return "Control";
  }

  if (field.name === originFields.finalStrategyAttainedDate)
  {
    return "Final Strategy Attained";
  }

  if (field.name === originFields.outDate)
  {
    return "Fire Declared Out";
  }

  if (field.name === originFields.initialFireStrategy)
  {
    return "Initial Strategy";
  }

  if (field.name === originFields.isInitialFireStrategyMet)
  {
    return "Initial Strategy Successful?";
  }

  if (field.name === originFields.incidentSize)
  {
    return "Incident Size (ac)";
  }

  if (field.name === originFields.calculatedAcres)
  {
    return "Calculated Size (ac)";
  }

  if (field.name === originFields.injuries)
  {
    return "Responder Injuries";
  }

  if (field.name === originFields.fatalities)
  {
    return "Responder Fatalities";
  }

  if (field.name === originFields.residencesDestroyed)
  {
    return "Residences Destroyed";
  }

  if (field.name === originFields.structuresDestroyed)
  {
    return "Other Structures Destroyed";
  }

  if (field.name === originFields.isFireCauseInvestigated)
  {
    return "Cause Investigated?";
  }

  if (field.name === originFields.fireCause)
  {
    return "Fire Cause";
  }

  if (field.name === originFields.fireCauseGeneral)
  {
    return "Fire Cause General";
  }

  if (field.name === originFields.fireCauseSpecific)
  {
    return "Fire Cause Specific";
  }

  if (field.name === originFields.inFuelTreatment)
  {
    return "In Fuels Treatment?";
  }

  if (field.name === originFields.isTrespass)
  {
    return "Trespass?";
  }

  if (field.name === originFields.report)
  {
    return "Report Narrative";
  }

  if (field.name === originFields.residencesThreatened)
  {
    return "Residences Threatened";
  }

  if (field.name === originFields.otherStructuresThreatened)
  {
    return "Other Structures Threatened";
  }

  if (field.name === perimeterFields.polygonDateTime)
  {
    return "Perimeter Date/Time";
  }

  if (field.name === perimeterFields.createDate)
  {
    return "Create Date";
  }

  if (field.name === perimeterFields.pooFireIntensityLevel)
  {
    return "Point of Origin Fire Intensity Level";
  }

  if (field.name === perimeterFields.primaryWeatherStationIdentifier)
  {
    return "Primary Weather Station Identifier";
  }

  if (field.name === perimeterFields.detectionMethod)
  {
    return "Detection Method";
  }

  if (field.name === "FeatureStatus")
  {
    return "Feature Status";
  }

  if (field.name === "FeatureAccess")
  {
    return "Feature Access";
  }

  if (field.name === "DeleteThis")
  {
    return "Delete This";
  }

  if (field.name === "FeatureCategory")
  {
    return "Feature Category";
  }

  if (field.name === "MapMethod")
  {
    return "Map Method";
  }

  if (field.name === "POOFireIntensityLevel")
  {
    return "POO Fire Intensity Level";
  }
  return field.alias;
}

export function getOriginValidationInfo(attributes, fieldInfos) {

  let errors = {};
  let invalidFields = [];
  let fireDiscoveryDate = null;

  if( !attributes || !fieldInfos ){
    return {
      isValid: true,
      invalidFields: [],
      errors: {}
    }
  }

  const regex = /\p{Extended_Pictographic}/ug;
  //const specialCharRegex = '[! $ * ; , | “ ?/"]';
  const specialCharRegex  = /[`!@$^*+;=[\]{}\\|àé,<>?]/;

  const hundredYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
  let previousDate = hundredYearsAgo;

  const chronologyError = "Before above date(s)";
  //Fire Ignition Date
  let attributeName = originFields.fireIgnitionDate
  let attributeValue = attributes[attributeName];
  if(attributeValue){
    const fireIgnitionDate = new Date(attributeValue);
    if(fireIgnitionDate <= hundredYearsAgo){
      errors[attributeValue] = "Must be within 100 years."
    }
    previousDate = fireIgnitionDate;
  }

  //Fire Discovery Date
  attributeName = originFields.discoveryDate;
  attributeValue = attributes[attributeName];
  if(attributeValue){
    fireDiscoveryDate = new Date(attributeValue);
    if(fireDiscoveryDate <= hundredYearsAgo){
      errors[attributeName] = "Must be within 100 years.";
    }
    if(fireDiscoveryDate < previousDate){
      errors[attributeName] = chronologyError;
    }
    previousDate = fireDiscoveryDate;
  }

  // Initial Response Date
  attributeName = originFields.initialResponseDate
  attributeValue = attributes[attributeName];
  if(attributeValue){
    const blockScopeDate = new Date(attributeValue);
    if(blockScopeDate < previousDate){
      errors[attributeName] = chronologyError;
    }
    previousDate = blockScopeDate;
  }

  //Containment Date
  attributeName = originFields.containmentDate
  attributeValue = attributes[attributeName];
  if(attributeValue){
    const blockScopeDate = new Date(attributeValue);

    if(fireDiscoveryDate) {
      if(blockScopeDate <= new Date(new Date().setFullYear(fireDiscoveryDate.getFullYear + 1)) ) {
        errors[attributeName] = "Must be within a year of Discovery";
      }
    }
    if(blockScopeDate < previousDate){
      errors[attributeName] = chronologyError;
    }
    previousDate = blockScopeDate;
  }

  //attributeName = originFields.fireGrowthCessationDate
  //attributeValue = attributes[attributeName];
  //if(attributeValue){
   // const blockScopeDate = new Date(attributeValue);

   // if(fireDiscoveryDate) {
    //  if(blockScopeDate <= new Date(new Date().setFullYear(fireDiscoveryDate.getFullYear + 1)) ) {
     //   errors[attributeName] = "Must be within a year of Discovery";
      //}
 //   }
//    if(blockScopeDate < previousDate){
 //     errors[attributeName] = chronologyError;
 //   }
 //   previousDate = blockScopeDate;
 // }
  attributeName = originFields.fireGrowthCessationDate
  attributeValue = attributes[attributeName];
  if(attributeValue){
    
    const blockScopeDate = new Date(attributeValue);

    if(fireDiscoveryDate) {
      if(blockScopeDate <= fireDiscoveryDate){
        errors[attributeName] = "Occurs before Discovery";
      }
    }

    const controlDateValue = attributes[originFields.controlDate];
    if(controlDateValue)
    {
      const controlDate = new Date(controlDateValue);
      if(controlDate) {
        if(blockScopeDate > controlDate){
          errors[attributeName] = "Occurs after Control";
        }
      }
    }
  }

  //Control Date
  attributeName = originFields.controlDate
  attributeValue = attributes[attributeName];
  if(attributeValue){
    const blockScopeDate = new Date(attributeValue);

    if(fireDiscoveryDate) {
      if(blockScopeDate <= new Date(new Date().setFullYear(fireDiscoveryDate.getFullYear + 1)) ) {
        errors[attributeName] = "Must be within a year of Discovery";
      }
    }
    if(blockScopeDate < previousDate){
      errors[attributeName] = chronologyError;
    }
    previousDate = blockScopeDate;
  }

    //Incident Type Category
    attributeName = originFields.incidentTypeCategory;
    attributeValue = attributes[attributeName];
    if (!attributeValue) {
      errors[attributeName] = "Incident Category cannot be null";
    }

  //Fire Out Date
  attributeName = originFields.outDate
  attributeValue = attributes[attributeName];
  if(attributeValue){
    const blockScopeDate = new Date(attributeValue);
    if(fireDiscoveryDate) {
      if(blockScopeDate <= new Date(new Date().setFullYear(fireDiscoveryDate.getFullYear + 1)) ) {
        errors[attributeName] = "Must be within a year of Discovery";
      }
    }
    if(blockScopeDate < previousDate){
      errors[attributeName] = chronologyError;
    }
    previousDate = blockScopeDate;
  }

  //Final Strategy Attained Date
  attributeName = originFields.finalStrategyAttainedDate
  attributeValue = attributes[attributeName];
  if(attributeValue){
    const blockScopeDate = new Date(attributeValue);

    if(fireDiscoveryDate) {
      if(blockScopeDate <= fireDiscoveryDate){
        errors[attributeName] = "Occurs before Discovery Date";
      }
    }
  }

  //FS Job Code
  attributeName = originFields.fsJobCode
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if( attributeValue.length !== 2) {
      errors[attributeName] = "Must be 2 characters";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //dispatchCenterId
  attributeName = originFields.dispatchCenterId
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //fireCauseComments
  attributeName = originFields.fireCauseComments
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //primaryWeatherStationIdentifier
  attributeName = originFields.primaryWeatherStationIdentifier
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //fireDepartmentId
  attributeName = originFields.fireDepartmentId
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //Final Fire Report Narrative
  attributeName = originFields.report
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if(attributeValue.length > 3999) 
    {
      errors[attributeName] = "Cannot exceed 3,999 characters";
    }

    if(regex.test(attributeValue)) 
      {
        errors[attributeName] = "Cannot contain emojis";
      }
  }
  
  //Incident Size
  attributeName = originFields.incidentSize
  attributeValue = attributes[attributeName];
  const isFalseAlarm = (attributes[originFields.incidentTypeCategory] === "FA");

  if(attributeValue)
  {
    if((!isNaN(attributeValue) && (attributeValue < 0.01) ) && !isFalseAlarm)
    {
      errors[attributeName] = "Must be greater than or equal to 0.01 acres";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //Calculated Acres
  attributeName = originFields.calculatedAcres
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if((!isNaN(attributeValue) && (attributeValue < 0.01) )&& !isFalseAlarm)
    {
      errors[attributeName] = "Must be greater than or equal to 0.01 acres";
    }
  }

  //Discovery Acres
  attributeName = originFields.discoveryAcres
  attributeValue = attributes[attributeName];
  if(attributeValue)
  {
    if(!isNaN(attributeValue) && (attributeValue < 0.01) )
    {
      errors[attributeName] = "Must be greater than or equal to 0.01 acres";
    }
  }

  attributeName = originFields.localIncidentIdentifier
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if( attributeValue.length < 6) {
      errors[attributeName] = "Must be at least 6 characters";
    }

    if( attributeValue.length > 10) {
      errors[attributeName] = "Must not exceed 10 characters";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }

  }

  attributeName = originFields.nonFederalFinancialCode
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if(attributeValue.length > 20) {
      errors[attributeName] = "Cannot exceed 20 characters";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  attributeName = originFields.name
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if( attributeValue.length < 2) {
      errors[attributeName] = "Must be at least 2 characters";
    }

    if( attributeValue.length > 50) {
      errors[attributeName] = "Must not exceed 50 characters";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }

    if (attributeValue.includes("  ")) 
    {
      errors[attributeName] ="Cannot contain multiple consecutive spaces";
    }

    if(attributeValue.startsWith(" ") || attributeValue.endsWith(" "))
    {
      errors[attributeName] = "Leading and trailing spaces not allowed";
    }

    if(attributeValue.startsWith("-"))
    {
      errors[attributeName] = "Cannot start with a hyphen";
    }

    if(specialCharRegex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain special characters";
    }

  }

  //ABCDMisc
  attributeName = originFields.abcdMisc
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if( attributeValue.length !== 4) {
      errors[attributeName] = "Must be 4 characters";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //Point of Origin Protecting Unit
  attributeName = originFields.pooProtectingUnit
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if(attributeValue.length > 6) {
      errors[attributeName] = "Character maximum of 6";
    }

    if(attributeValue.length < 5) {
      errors[attributeName] = "Must be at least 5 characters";
    }

    if(attributeValue.startsWith(" ") || attributeValue.endsWith(" "))
    {
      errors[attributeName] = "Leading and trailing spaces not allowed";
    }

    if(attributeValue.includes("-"))
    {
      errors[attributeName] = "Dashes not allowed";
    }
    
    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //Point of Origin Jurisdictional Unitds
  attributeName = originFields.pooJurisdictionalUnit
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if( attributeValue.length < 5 || attributeValue.length > 6) {
      errors[attributeName] = "Character minimum of 5 maximum of 6";
    }

    if(attributeValue.startsWith(" ") || attributeValue.endsWith(" "))
    {
      errors[attributeName] = "Leading and trailing spaces not allowed";
    }

    if(attributeValue.includes("-"))
    {
      errors[attributeName] = "Dashes not allowed";
    }

    if(regex.test(attributeValue)) 
    {
      errors[attributeName] = "Cannot contain emojis";
    }
  }

  //Point of Origin Jurisdictional Parent Unit
  /*attributeName = originFields.pooJurisdictionalUnitParentUnit
  attributeValue = attributes[attributeName];
  if(attributeValue){
    if( attributeValue.length < 5 || attributeValue.length > 6) {
      errors[attributeName] = "Character minimum of 5 maximum of 6";
    }
  }*/

  //whole number check for integers
  if(fieldInfos) {
    const integerFieldInfos = fieldInfos.filter(info => {return ["integer","small-integer"].includes(info.type)});
    for (let fieldInfo of integerFieldInfos) {
      const value = attributes[fieldInfo.name];
      if(value !== null && value !== undefined && (value % 1 !== 0) ){
        errors[fieldInfo.name] = "Expecting whole number";
      }
    }
  }

  //positive number check
  const mustBePositiveNumbers = [
    originFields.calculatedAcres,
    originFields.incidentSize,
    originFields.fatalities,
    originFields.injuries,
    originFields.residencesDestroyed,
    originFields.residencesThreatened,
    originFields.structuresDestroyed,
    originFields.otherStructuresThreatened
  ];
  for (attributeName of mustBePositiveNumbers) {
    const value = attributes[attributeName];
    if(value !== null && value !== undefined && (value < 0) )
    {
      errors[attributeName] = "Expecting positive number";
    }
  }



  let isValid = true;
  for(var key in errors) {
    if(errors.hasOwnProperty(key)){
      if(errors[key]){
        isValid = false;
        invalidFields.push(key);
      }
    }
  }

  const validationInfo = {
    isValid: isValid,
    invalidFields: invalidFields,
    errors: errors
  }
  return validationInfo;
}

export function isClearableDateField(fieldName, canWrite)
{
  const clearableDateFields = [originFields.fireIgnitionDate, originFields.initialResponseDate,
    originFields.fireGrowthCessationDate, originFields.estimatedContainmentDate, originFields.containmentDate,
    originFields.controlDate, originFields.outDate, originFields.finalStrategyAttainedDate];

  return (canWrite) ?  clearableDateFields.includes(fieldName) : false;
}

export function isAcreageField(fieldName)
{
  const acreageFields = [originFields.calculatedAcres, originFields.incidentSize];
  return acreageFields.includes(fieldName);
}

export function getAcresFromIncident(incident)
{
  return Math.max(incident.attributes[originFields.calculatedAcres], incident.attributes[originFields.incidentSize]);
}

export function getDomainForCauses (fieldValue, codedValues)
{
  if (fieldValue && codedValues)
  {
    const matchingCodedValue = codedValues.find(cv => {return cv.code === fieldValue });
     if (matchingCodedValue)
     {
       return matchingCodedValue.name
     }
     else
     {
       return fieldValue;
     };
  }

}

export function getNameForCategory(categoryCode)
{
  switch (categoryCode)
  {
    case "BR":
      return "Emergency Stabilization / BAER";
    case "NS":
      return "Non-Statistical/Other";
    case "DF":
      return "Debris/Product Fire";
    case "FR":
      return "Fire Rehabilitation";
    case "SU":
      return "Incident/Event Support";
    case "PP":
      return "Preparedness/Preposition";
    case "RX":
      return "Prescribed Fire";
    case "SF":
      return "Structure Fire";
    case "VF":
      return "Vehicle Fire";
    case "WF":
      return "Wildfire";
    case "CX":
      return "Incident Complex";
    case "FA":
      return "False Alarm";
    case "OR":
      return "Out of Area Response";
    case "GF":
      return "Foreign Incident";
    case "IM":
      return "International Mobilization";
    default:
      return categoryCode;
  }
}

export function getNameForKind(kindCode)
{
  switch (kindCode)
  {
    case "FI":
      return "Fire";
    case "HZ":
      return "Hazardous Conditions";
    case "AC":
      return "Accident";
    case "AP":
      return "Agency Program Support";
    case "PA":
      return "Public Assistance";
    case "SR":
      return "Search / Rescue / Recovery";
    case "ND":
      return "Natural Disaster & Severe Weather";
    case "TR":
      return "Training and Proficency";
    default:
      return kindCode;
  }
}

export function isPerimeterMultipart(perimeter)
{
  if (!perimeter || !perimeter.geometry || !perimeter.geometry.rings)
  {
    return false;
  }

  if (perimeter.geometry.rings.length > 1)
  {
    return true;
  }

  return false;
}

export function isPerimeterTriangleOrMissing(perimeter)
{
  return (!perimeter || !perimeter.geometry || !perimeter.geometry.rings) ? true : isPerimeterTriangle(perimeter);
}

export function getTriangleSideLengthForAcreage(acres)
{ 
    const squareFootagePerAcre = 43560;
    const squareRootOfThree = 1.732;
    const totalAcreFootage = (squareFootagePerAcre * acres);
    const sSquared = (4 * totalAcreFootage) / squareRootOfThree;
    return Math.sqrt(sSquared);
}

export function distanceToVertex(sideLengthInFeet)
{ 
  const squareRootOfThree = 1.732;
  return (squareRootOfThree / 3) * sideLengthInFeet;
}

export function isPerimeterTriangle(perimeter)
{
  let lat = [];
  let long = [];

  if (!perimeter || !perimeter.geometry || !perimeter.geometry.rings)
  {
    return false;
  }

  if (perimeter.geometry.rings[0].length === 4 && perimeter.geometry.rings.length === 1)
  {
    for (var i = 0; i < perimeter.geometry.rings[0].length; i++)
    {
      let item = perimeter.geometry.rings[0][i];
      let containsSameLat = lat.includes(item[0]);
      let containsSameLong = long.includes(item[1]);

      if (containsSameLat && containsSameLong)
      {
        return true;
      }
      else
      {
        lat.push(item[0]);
        long.push(item[1]);
      }
    }
    return false;
  }
  return false;
}


export function getPerimeterValidationInfo(attributes, fieldInfos) {
  let errors = {};
  let invalidFields = [];

  if (attributes === null || attributes === undefined) 
  {
    console.log("Error: Called getPerimeterValidationInfo but with null or undefined attributes");
  }
  let attributeName = perimeterFields.mapMethod
  let attributeValue = attributes[attributeName];
  if(attributeValue){
    if(attributeValue === perimeterFields.mapMethodAutoGenerated)
    {
      errors[attributeName] = "Update auto generated perimeter and map method."
    }
  }

  let isValid = true;
  for(var key in errors) {
    if(errors.hasOwnProperty(key)){
      if(errors[key])
      {
        isValid = false;
        invalidFields.push(key);
      }
    }
  }

  const validationInfo = {
    isValid: isValid,
    invalidFields: invalidFields,
    errors: errors
  }

  return validationInfo;
}

export function findDuplicateAttributes(baseIncident, incident)
{
    var unchangedValues = [];
    for (var prop in baseIncident)
    {
      if(incident.attributes.hasOwnProperty(prop))
        {
          if (baseIncident[prop] === incident.attributes[prop])
          {
            unchangedValues.push(prop);
          }
        }
    }
  return unchangedValues;
}

export function isIncidentComplete(incident)
{
    return (getMissingFieldsCount(incident) === 0 && !incident.attributes[originFields.isQuarantined]);
}

export function getMissingFieldsCount(incident) 
{
    if (incident.attributes[originFields.incidentTypeCategory] !== "WF")
    {
      return 0;
    }

    let count = 0;
    const requiredFields = getRequiredFields(incident);
    const missingFields = requiredFields.filter(field => { return incident.attributes[field] === undefined || incident.attributes[field] === null });

    count =  missingFields.length;

    return (count <= 0) ? 0 : count;
}

export function getAcresFieldName (code) 
{
  switch (code) 
  {
    case 'BIA':
      return 'AcresBIA';

  case 'BLM':
    return 'AcresBLM';

  case 'BOR':
    return 'AcresBOR';
    
  case 'DOD':
    return 'AcresDOD';

  case 'DOE':
    return 'AcresDOE';

  case 'NPS':
    return 'AcresNPS';

  case 'USFS':
    return 'AcresUSFS';

  case 'USFWS':
    return 'AcresUSFWS';

  case 'Foreign':
    return 'AcresForeign';

  case 'Tribal':
    return 'AcresTribal';

  case 'City':
    return 'AcresCity';

  case 'County':
    return 'AcresCounty';

  case 'State':
    return 'AcresState';

  case 'Private':
    return 'AcresPrivate';

  case 'ANCSA':
    return 'AcresANCSA';

  case 'OthLoc':
    return 'AcresOtherLocal';

  case 'OthFed':
    return 'AcresOtherFederal';

    default:
      return '';
  }
}
export function getSQLDateEndOfDay(date)
{
  date = new Date(date);
  date.setHours(23,59,59,999);
  return date.toISOString();
}

export function getSQLDate(date)
{
  return new Date(date).toISOString();
}


export function getIncidentStatus(incident)
{
  if(incident.attributes[originFields.isQuarantined])
  {
    return enums.incidentStatus.conflict;
  }

  if(incident.attributes[originFields.incidentTypeCategory] === 'RX')
  {
    return enums.incidentStatus.prescribed;
  }

  if(incident.attributes[originFields.incidentTypeCategory] !== 'RX' && incident.attributes[originFields.incidentTypeCategory] !== 'WF')
  {
    return enums.incidentStatus.nonWildfire;
  }

  if(isIncidentCertified(incident))
  {
    return enums.incidentStatus.certified;
  }
  else if(isIncidentComplete(incident) && !incident.attributes[originFields.isQuarantined])
  {
    return enums.incidentStatus.complete;
  }
  else
  {
    return enums.incidentStatus.incomplete;
  }
}

export function getRenderSize(incident)
{
  var calculatedAcres = incident.attributes[originFields.calculatedAcres] || 0;
  var incidentSize = incident.attributes[originFields.incidentSize] || 0;

  return Math.max(calculatedAcres, incidentSize);
}

export function belowUniquenessThreshold(incident)
{
  if(incident.attributes && incident.attributes[originFields.minUniqueness])
  {
    return incident.attributes[originFields.minUniqueness] <= .25;
  }
}

export function isIncidentFederal(incident)
{
  if(incident.attributes && incident.attributes[originFields.incidentJurisdictionalAgency])
  {
    return (enums.federal_POOJurisdictionalAgency.indexOf(incident.attributes[originFields.incidentJurisdictionalAgency]) !== -1);
  }
  else
  {
    if(incident.attributes && incident.attributes[originFields.landownerKind]) 
    {
      return incident.attributes[originFields.landownerKind] === "Federal";
    }
    return false;
  }
}

export function isIncidentAlaska(incident)
{
  if(incident.attributes && incident.attributes[originFields.state])
  {
    return incident.attributes[originFields.state].indexOf("AK") !== -1;
  }
  else
  {
    return false;
  }
}

export function isIncidentCertified(incident)
{
  if (incident && incident.attributes && incident.attributes[originFields.certifiedField])
  {
    return incident.attributes[originFields.certifiedField] === originFields.certifiedCodedValue;
  }
  else {
    return null;
  }
}

export function is209(incident) {
  if (incident && incident.attributes && incident.attributes[originFields.certifiedField]){
    return incident.attributes[originFields.certifiedField] === originFields.ics209CodedValue;
  }
  else {
    return null;
  }
}

export function getRequiredFields(incident) {
  
  if (incident.attributes[originFields.incidentTypeCategory] !== "WF") 
  {
    return [];
  }

  const incidentDiscoveryDate = new Date(incident.attributes[originFields.discoveryDate]);
  const requirementDate = new Date(2023, 8, 1, 1, 1, 1, 999);

  const updatedCauseValidationsRequired = incidentDiscoveryDate >= requirementDate;

  const isAlaska = isIncidentAlaska(incident);
  const isFederal = isIncidentFederal(incident);

  var requiredFields = (isAlaska) ? [...originFields.requiredAlaska]  : ((isFederal) ?  [...originFields.requiredFederal] : [...originFields.requiredAllAgencies]);

  //2024 Updated Cause Requirements
  if (updatedCauseValidationsRequired) 
  {
    const hasFireCause = (incident.attributes !== null && incident.attributes[originFields.fireCauseId]);
    const hasFireCauseGeneral = (incident.attributes !== null && incident.attributes[originFields.fireCauseGeneralId]);
    const hasFireCauseSpecific = (incident.attributes !== null && incident.attributes[originFields.fireCauseSpecificId]);
    const hasFireSpecificCauseDetail = (incident.attributes !== null && incident.attributes[originFields.fireCauseSpecificDetailID]);
    const hasActivityGroup = (incident.attributes !== null && incident.attributes[originFields.fireCauseActivityGroupID]);
    
    var ageCategoryRequired = true;
    var prohibitedRequired = true;
    var remarksRequired = false;

    //Always add Fire Cause Specific
    if (!requiredFields.includes(originFields.fireCauseSpecificId)) 
    {
      requiredFields.push(originFields.fireCauseSpecificId);
    }

    if (hasFireCause && hasFireCauseGeneral) 
    {
      //Natural/Natural
      if (incident.attributes[originFields.fireCauseId] === 1 && incident.attributes[originFields.fireCauseGeneralId] === 1) 
      { 
        ageCategoryRequired = false;
        prohibitedRequired = false;
      }

      //Undetermined, Undetermined
      if (incident.attributes[originFields.fireCauseId] === 2 && incident.attributes[originFields.fireCauseGeneralId] === 2) 
      { 
          ageCategoryRequired = false;
          prohibitedRequired = false;
          remarksRequired = true;
      }

      //Human, Undetermined
      if (incident.attributes[originFields.fireCauseId] === 3 && incident.attributes[originFields.fireCauseGeneralId] === 2) 
      { 
          ageCategoryRequired = false;
          prohibitedRequired = false;
          remarksRequired = true;
      }

      //Human, Power Gen or Railroad, age category not required
      if (incident.attributes[originFields.fireCauseId] === 3 && (incident.attributes[originFields.fireCauseGeneralId] === 7|| incident.attributes[originFields.fireCauseGeneralId] === 8)) 
      { 
          ageCategoryRequired = false;
      }

      if (hasFireCauseSpecific && (incident.attributes[originFields.fireCauseSpecificId] === 3 || incident.attributes[originFields.fireCauseSpecificId] === 4)) {
        remarksRequired = true;
      }

      if (hasFireSpecificCauseDetail && (incident.attributes[originFields.fireCauseSpecificDetailID] === 60 || incident.attributes[originFields.fireCauseSpecificDetailID] === 61)) {
        remarksRequired = true;
      }

      if (hasActivityGroup && (incident.attributes[originFields.fireCauseActivityGroupID] === 17 || incident.attributes[originFields.fireCauseActivityGroupID] === 18)) {
        remarksRequired = true;
      }

      //Add the stuff:
      if (ageCategoryRequired && !requiredFields.includes(originFields.fireCauseAgeCategoryID)) 
      {
        requiredFields.push(originFields.fireCauseAgeCategoryID);
      }

      if (prohibitedRequired && !requiredFields.includes(originFields.isCauseProhibited)) 
      {
        requiredFields.push(originFields.isCauseProhibited);
      }

      if (remarksRequired && !requiredFields.includes(originFields.fireCauseComments)) 
      {
        requiredFields.push(originFields.fireCauseComments);
      }
    }

  }   //end of 2024 fire cause requirements



  //Remove FireCode from requiredFields if ABCDMisc is populated
  if (incident.attributes !== null && incident.attributes[originFields.abcdMisc] && incident.attributes[originFields.abcdMisc].length === 4) {
    requiredFields = requiredFields.filter(name => name !== originFields.fireCode);
  }

  //Remove InitialFireStrategy from requiredFields if POOJurisdictionalUnit != USFS
  if (incident.attributes !== null && incident.attributes[originFields.incidentJurisdictionalAgency] && (incident.attributes[originFields.incidentJurisdictionalAgency] !== "USFS" && incident.attributes[originFields.incidentJurisdictionalAgency] !== "FS")) {
    requiredFields = requiredFields.filter(name => name !== originFields.initialFireStrategy);
  }

  //Remove FireCode/ABCDMisc from requiredFields if pooProtectingAgency is not federal
  if (incident.attributes !== null && incident.attributes[originFields.pooProtectingAgency] && enums.federal_POOJurisdictionalAgency.indexOf(incident.attributes[originFields.pooProtectingAgency]) === -1) {
    requiredFields = requiredFields.filter(name => name !== originFields.fireCode);
    requiredFields = requiredFields.filter(name => name !== originFields.abcdMisc);
  }

  return requiredFields;

}

export function getDisplayValue(fieldInfo, value){
  if (fieldInfo.domain) {
    const matchingCodedValue = fieldInfo.domain.codedValues.find(cv => {return cv.code === value });
    return  (matchingCodedValue) ? matchingCodedValue.name : value;
  }
  const isDate = originFields.dateFieldsWithTypeDouble.includes(fieldInfo.name);
  if(fieldInfo.type === "date" || isDate){
    return moment(value).format("MM/DD/YYYY [at] h:mm A");
  }

  return value;
}

